import React from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import styles from './ActionBar.module.scss';

const ActionBar = ({ searchKeywords, onChangeSearch }) => {
    return (
        <div className={styles.Wrapper}>
            <div className={styles.Item}>
                <InputGroup>
                    <InputGroup.Text className={styles.Prepend}>
                        <FontAwesomeIcon icon={faSearch} />
                    </InputGroup.Text>
                    <FormControl
                        value={searchKeywords}
                        onChange={e => onChangeSearch(e.target.value)}
                        placeholder="Search"
                    />
                </InputGroup>
            </div>
        </div>
    );
};

export default ActionBar;
